import type { FaireProductEntity } from "../../entity_types/product";

export const p_kfwr9rsz7b: FaireProductEntity = {
  token: "p_kfwr9rsz7b",
  type: "product",
  name: "Mountain Valley Spring Water – Aluminum Bottle",
  brandToken: "b_9z8pu8jvce",
  brandName: "Rising Sun Distributors",
  imageUrl:
    "https://cdn.faire.com/fastly/c530833dd819e73af3c4601ae9f4e47feefe0acdf170cc3d90125e3dd70378ec.webp",
  galleryImageUrls: [],
  priceDollars: 5.07,
  description:
    "Bring your customers a premium hydration option that delivers both quality and sustainability. Bottled at the source in the Ouachita Mountains since 1871, Mountain Valley Spring Water is naturally alkaline, sodium-free, and rich in essential minerals for a crisp, refreshing taste.\n\nThis version comes in lightweight, infinitely recyclable aluminum bottles — making it a smart choice for eco-conscious shoppers looking to cut down on single-use plastics. The sleek design is also perfect for on-the-go lifestyles, from gyms and yoga studios to cafes, hotels, and specialty retail.",
  tags: [],
  msrpDollars: 10.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:49.457Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
